import { useState } from 'react'
import WizrFlexLayout from '../WizrFlexLayout'
import WizrText from '../WizrText'
import WizrInput from '../WizrInput'
import WizrButton from '../WizrButton'
import styled from 'styled-components'

const StyledContainer = styled(WizrFlexLayout)`
  gap: 10px;
`

interface IImportWorkflowNameConflict {
  errorMessage?: string
  onSubmit: (newName: string) => void
  onCancel: () => void
}

const ImportWorkflowNameConflict = ({
  errorMessage = 'A workflow with this name already exists. Please enter a unique name.',
  onSubmit,
  onCancel,
}: IImportWorkflowNameConflict): JSX.Element => {
  const [newName, setNewName] = useState('')
  const [showValidation, setShowValidation] = useState(false)

  const handleSubmit = () => {
    const trimmed = newName?.trim()
    if (!trimmed) {
      setShowValidation(true)
      return
    }
    onSubmit(trimmed)
  }

  return (
    <StyledContainer flexDirection="column" background="#FFF" style={{ padding: '8px 0' }}>
      <WizrText type="sub1" style={{ textAlign: 'left', fontWeight: 600, color: '#1D1F22' }}>
        Workflow Name Already Exists
      </WizrText>
      <WizrText type="body2" textColor="#5D5F62" style={{ textAlign: 'left' }}>
        A workflow with this name already exists. Please enter a unique name.
      </WizrText>
      <WizrFlexLayout background='transparent' flexDirection="column" alignItems="stretch">
        <WizrInput
          style={{ width: '100%', borderRadius: 12, minHeight: 44 }}
          background="#F2F4F9"
          value={newName}
          onChange={(value: any) => {
            setNewName(value)
            if (showValidation && value?.trim()) setShowValidation(false)
          }}
          placeholder="Enter Workflow Name"
          showError={showValidation}
          errorMessage={showValidation ? 'Please enter a name' : undefined}
        />
      </WizrFlexLayout>
      <WizrFlexLayout background='#FFF' flexDirection="row" justifyContent="flex-end" style={{ gap: 8 }}>
        <WizrButton type="default" text="Cancel" onClick={onCancel} style={{ borderRadius: '20px' }} />
        <WizrButton text="Submit" onClick={handleSubmit} style={{ borderRadius: '20px' }} />
      </WizrFlexLayout>
    </StyledContainer>
  )
}

export default ImportWorkflowNameConflict
